var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShareNetwork',{attrs:{"network":_vm.network,"url":_vm.link,"title":((_vm.auth.name) + " share post"),"description":_vm.post.content}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }